import axiosInstance from '../../utility/axios';
import { POST_TYPE_NAME } from '../../utility/constants';

export const showError = (errorMessage) => ({
    type: 'SHOW_ERROR',
    errorMessage
});

export const startEMCLeadStat = () => ({
    type: 'START_GET_EMC_LEAD_STAT',
});

export const getEMCLeadStatSuccess = (formData) => ({
    type: 'GET_EMC_LEAD_STAT_SUCCESS',
    formData
});

export const getEMCLeadStat = (id) => {
    return (dispatch) => {
        dispatch(startEMCLeadStat());
        axiosInstance.get(`emc-leads-csv-upload/${id}`)
            .then((response) => {
                if (response.data.formData === false) { // no post yet
                } else { // has post
                    console.log('response.data emc content stat: ', response.data);
                    dispatch(getEMCLeadStatSuccess(response.data));
                }
            })
            .catch((error) => {
                dispatch(showError(error));
                console.log(error);
            });
    }
};

export const startGetEMCLeadStats = () => ({
    type: 'START_GET_EMC_LEAD_STATS',
});

export const getEMCLeadStatsSuccess = (emcLeadStats) => ({
    type: 'GET_EMC_LEAD_STATS_SUCCESS',
    emcLeadStats
});

// get all emc content stats by emcStatId
export const getEMCLeadStats = (emcStatId, queryParams) => {
    return (dispatch) => {
        let url = `emc-lead-stats/${emcStatId}`;
        if (queryParams) {
            url = `emc-lead-stats/${emcStatId}/${queryParams}`;
        }
        console.log('get emc content stats url: ', url);
        dispatch(startGetEMCLeadStats());
        axiosInstance.get(url)
            .then((response) => {
                dispatch(getEMCLeadStatsSuccess(response.data));
            })
            .catch((error) => {
                dispatch(showError(error));
                console.log(error);
            });
    }
};

export const startCreateEMCLeadStat = () => ({
    type: 'START_CREATE_EMC_LEAD_STAT'
});

export const createEMCLeadStatSuccess = (emcLeadStats) => ({
    type: 'CREATE_EMC_LEAD_STAT_SUCCESS',
    emcLeadStats
});

export const clearEMCLeadStatSuccess = () => ({
    type: 'CREATE_EMC_LEAD_STAT_CLEAR_SUCCESS'
});

export const createEMCLeadStat = (formData, emcContentStatId) => {
    console.log('creating emc lead stat', formData);
    return (dispatch) => {
        dispatch(startCreateEMCLeadStat());
        axiosInstance.post(`emc-leads-csv-upload/${emcContentStatId}`, formData,)
            .then((response) => {
                dispatch(createEMCLeadStatSuccess(response.data.leads));
                setTimeout(() => {
                    dispatch(clearEMCLeadStatSuccess());
                }, 1000)
            })
            .catch((error) => {
                dispatch(showError());
                console.log(error);
            });
    }
};

export const startEMCLeadStatUpdate = () => ({
    type: 'START_EMC_LEAD_STAT_UPDATE',
});

export const updateJobSuccess = (formData) => ({
    type: 'UPDATE_EMC_LEAD_STAT_SUCCESS',
    formData
});

export const updateJob = (formData, emcLeadStatId) => {
    return (dispatch) => {
        dispatch(startEMCLeadStatUpdate());
        axiosInstance.put(`emc-leads-csv-upload/${emcLeadStatId}`, formData)
            .then((response) => {
                dispatch(updateJobSuccess(formData));
            })
            .catch((error) => {
                dispatch(showError(error));
                console.log(error);
            });
    }
};

export const startRemoveEMCLeadStat = () => ({
    type: 'START_REMOVE_EMC_LEAD_STAT'
});

export const removeEMCLeadStatSuccess = (emcLeadStatIds) => ({
    type: 'REMOVE_EMC_LEAD_STAT_SUCCESS',
    emcLeadStatIds
});

export const clearEMCLeadDeleteSuccess = () => ({
    type: 'REMOVE_EMC_LEAD_STAT_CLEAR_SUCCESS'
});

export const removeEMCLeadStat = (emcLeadStatIds) => {
    return (dispatch) => {
        const items = {
            itemsToDelete: emcLeadStatIds
        };
        dispatch(startRemoveEMCLeadStat());
        axiosInstance.delete('emc-lead-stats', { data: items })
            .then((response) => {
                dispatch(removeEMCLeadStatSuccess(emcLeadStatIds));
                console.log('emc-lead-stats removed!');
                setTimeout(() => {
                    dispatch(clearEMCLeadDeleteSuccess());
                }, 1000)
            })
            .catch((error) => {
                dispatch(showError());
                console.log(error);
            });
    }
};

